import React from "react";
import { Grid } from "@mui/material";
import { OdometerProps } from "@/utils/interface";
import FormInputField from "../CommonComponents/FormInputField";

const Odometer = ({ asset, allValues, handle, getLocalAndLenderError, isDisableEdit }: OdometerProps) => {
  const { searchVehicleLoader = false } = asset;

  return (
    <React.Fragment>
      <Grid container direction="row" style={{ margin: "0 0 0 0" }}>
        <Grid container spacing={1}>
          <FormInputField
            fieldName="odometer"
            label="Odometer"
            // placeholder="Odometer"
            value={allValues?.odometer}
            error={getLocalAndLenderError({ fieldName: "odometer" })}
            disabled={searchVehicleLoader || isDisableEdit}
            onChange={handle.onChangeField}
            onBlur={handle.blurFn}
            inputProps={{ maxLength: 50 }}
          />

          <FormInputField
            fieldName="serialNumber"
            label="Serial Number"
            // placeholder="Serial Number"
            value={allValues?.serialNumber}
            error={getLocalAndLenderError({ fieldName: "serialNumber" })}
            disabled={searchVehicleLoader || isDisableEdit}
            onChange={handle.onChangeField}
            onBlur={handle.blurFn}
            inputProps={{ maxLength: 50 }}
          />
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

export default Odometer;
